import React, { useState } from "react"
import _ from "lodash"

import RowAddRemove from "components/table/carousel/row-add-remove"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

type Item_t = object & {
  i: number
}

const RecoveriesTenantMgmtFee = (props: {rowData: [], field: string, defaults: {}, namedItems:object, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "tenantMgmtFeeItems")
  const emptyItem = {
    percent: null,
    revenueType: props.defaults['recoveryTenantMgmtFeeRevenueType']
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i:0}])

  function updateData(val:any, field:string[]):void {
    let nextItems = _.cloneDeep(items);
    nextItems[field[0]][field[1]] = val
    setItems(nextItems)
    nextItems = nextItems.map(({i, ...rest}) => rest)
    let nextData = _.cloneDeep(props.rowData[props.field])
        nextData = {...nextData, 'tenantMgmtFeeItems': nextItems}
    props.persist(nextData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let nextData = _.cloneDeep(props.rowData[props.field])
    let nextItems = items.map((item, i) => { return {...item}})
    setItems(nextItems)
    let strippedItems:any = nextItems.map(({i, ...rest}) => rest)
    if (strippedItems.length === 1 && _.isEqual(strippedItems[0], emptyItem)) delete nextData['tenantMgmtFeeItems']
    else nextData = {...nextData, 'tenantMgmtFeeItems': strippedItems}
    props.persist(nextData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i')
  const item_attrs = (field) => field_attrs('recoverydetail', `${props.field}.tenantMgmtFeeItems`)(field)(props.rowData, props)

  const params = {
    attrs: item_attrs,
    data: items,
    persist: updateData
  }

  const reportTagOptions = props.namedItems?.['reportTags']?.map(tag => {
    if (tag.code) return {label: tag.code, value: tag.reporttagid}
  })

  return (
    <div>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row recoveries">
            <div>
              { i === 0 && <label>Percent</label> }
              <NumberInput
                className="automated"
                field={[row['i'], 'percent']}
                min={-100}
                max={100}
                readPrecision={4}
                writePrecision={4}
                {...params}
              />
            </div>
            <div>
              { i === 0 && <label>Amt Type</label> }
              <DropdownInput
                className="automated"
                field={[row['i'], 'revenueType']}
                options={['Rent', 'Rent + Recovery', 'All Revenues']}
                default="Rent + Recovery"
                {...params}
              />
            </div>
            <div>
            { i === 0 && <label>Report Tag</label> }
              <DropdownInput
                className="automated"
                field={[row['i'], 'reportTagNamedItemId']}
                options={reportTagOptions}
                onClear={() => updateData(null, [row['i'], 'reportTagNamedItemId'])}
                {...params}
              />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={renderItems} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default RecoveriesTenantMgmtFee
